{
    "common": {
        "mon": "Po",
        "tue": "Út",
        "wed": "St",
        "thu": "Čt",
        "fri": "Pá",
        "sat": "So",
        "sun": "Ne",
        "jan": "Led",
        "feb": "Úno",
        "mar": "Bře",
        "apr": "Dub",        
        "jun": "Čer",
        "jul": "Čvc",
        "aug": "Srp",
        "sep": "Zář",
        "oct": "Říj",
        "nov": "Lis",
        "dec": "Pro",
        "january": "Leden",
        "february": "Únor",
        "march": "Březen",
        "april": "Duben",
        "may": "Květen",
        "june": "Červen",
        "july": "Červenec",
        "august": "Srpen", 
        "september": "Září",
        "october": "Říjen",
        "november": "Listopad",
        "december": "Prosinec",
        "checkin": "Příjezd",
        "checkout": "Odjezd",
        "room": "Pokoj",
        "rooms": "Pokoje",
        "adult": "Dospělý",
        "adults": "Dospělí",
        "edit": "Upravit",
        "editCap": "UPRAVIT",
        "delete": "Smazat",
        "deleteCap": "SMAZAT",
        "localTime": "Místní čas",
        "back": "ZPĚT",
        "home": "DOMŮ",
        "yes": "ANO",
        "no": "NE",
        "left": "Zbývá",
        "hour": "Hodina",
        "hours": "Hodiny",
        "night": "noc",
        "nights": "noci",
        "for": "pro",
        "why": "Proč",
        "get": "Získat",
        "more": "Více",
        "agree": "SOUHLASÍM",
        "disagree": "NESOUHLASÍM",
        "basedOn": "na základě",
        "error": "Došlo k chybě, zkuste to prosím později",
        "error2": "Selhalo, zkuste to znovu!",
        "error3": "Došlo k chybě!!",
        "error4": "Došlo k chybě!! Zkuste to prosím znovu",
        "error5": "Omlouváme se!! Došlo k chybě. Zkuste to prosím znovu za chvíli.",
        "hi": "Ahoj",
        "to": "do",
        "free": "Zdarma",
        "per": "Za",
        "at": "v",
        "day": "Den",
        "days": "Dny",
        "time": "Čas",
        "of": "z",
        "photo": "Fotografie",
        "photos": "Fotografie",
        "done": "Hotovo",
        "fullStay": "Celý pobyt",
        "date": "Datum",
        "and": "a",
        "bookingDetail": "Detail rezervace",
        "Back": "Zpět",
        "Home": "Domů"
    },
    "userPopup": {
        "myAccount": "Můj účet",
        "welcome": "Vítejte",
        "user": "Uživatel",
        "findMyBookings": "NAJÍT MOJE REZERVACE",
        "viewProfile": "ZOBRAZIT PROFIL",
        "makeAReservarion": "VYTVOŘIT REZERVACI",
        "logout": "ODHLÁSIT SE",
        "loginCap": "PŘIHLÁSIT SE",
        "login": "Přihlásit se",
        "invalidCredentials": "Neplatné přihlašovací údaje",
        "invalidEmail": "Neplatný e-mail",
        "passwordIsRequired": "Heslo je povinné",
        "minChar8": "minimálně 8 znaků",
        "tooShort": "Příliš krátké!",
        "tooLong": "Příliš dlouhé!",
        "required": "Povinné",
        "emailInvalid": "Zadejte platný e-mail",
        "passwordInvalid": "Zadejte platné heslo",
        "phNumInvalid": "Telefonní číslo není platné",
        "signupCap": "ZAREGISTROVAT SE",
        "signup": "Zaregistrovat se",
        "verifyText": "Ověřte, že jste to vy",
        "verifyText2": "Poslali jsme ověřovací kód na váš e-mail",
        "verificationCode": "Ověřovací kód",
        "didNotReceiveEmail": "Neobdrželi jste e-mail",
        "clickToResend": "Klikněte pro opětovné odeslání",
        "verifyAndSignIn": "Ověřit a přihlásit se",
        "otpSentSuccessfully": "OTP úspěšně odesláno",
        "somethingWentWrong": "Něco se pokazilo, zkuste to prosím znovu",
        "otpError": "Zadejte prosím platné číslo",
        "otpError2": "Zadejte prosím pouze čísla",
        "otpError3": "Nesprávné OTP, zkuste to prosím znovu",
        "otpError4": "OTP vypršelo, klikněte na Znovu odeslat a zkuste to znovu",
        "otpError5": "Zkuste to prosím znovu",
        "forgetPassword": "Zapomenuté heslo",
        "submitError": "Uživatel neexistuje!",
        "userExistError": "Uživatel již existuje",
        "checkYourEmail": "Zkontrolujte svůj e-mail",
        "passwordResetLinkSent": "Poslali jsme odkaz pro obnovení hesla na",
        "noWorriesResetInstructions": "Žádné starosti, pošleme vám pokyny k obnovení.",
        "enterYourEmail": "Zadejte svůj e-mail",
        "resetMyPassword": "OBNOVIT MÉ HESLO",
        "setANewPassword": "Nastavit nové heslo",
        "newPassword": "Nové heslo",
        "confirmPassword": "Potvrdit heslo",
        "confirmPasswordError": "Hesla se musí shodovat",
        "backToLogin": "Zpět na přihlášení",
        "dontHaveAccount": "Nemáte účet?",
        "alreadyHaveAccount": "Již máte účet?",
        "memberDiscount1": "Získáte",
        "memberDiscount2": "členskou slevu navždy.",
        "discount1": "Spravujte všechny své rezervace z jednoho místa.",
        "discount2": "Zaregistrujte se pro personalizovaná doporučení a přizpůsobené zážitky!!",
        "discount3": "Připojte se k naší komunitě spokojených hostů a začněte plánovat svůj pobyt.",
        "leftGridText1": "Spravujte všechny své rezervace z jednoho místa",
        "leftGridText2": "Zaregistrujte se pro personalizovaná doporučení a přizpůsobené zážitky!!",
        "leftGridText3": "Připojte se k naší komunitě spokojených hostů a začněte plánovat svůj pobyt",
        "gridDiscountText1": "členská sleva na",
        "gridDiscountText2": "vybrané nemovitosti navždy",
        "gridDiscountText3": "Přihlaste se pro přizpůsobený zážitek navždy",
        "gridDiscountText4": "Získejte exkluzivní členské výhody",
        "findBookingError": "Váš e-mail a ID rezervace se neshodují",
        "verifyAndConfirmBooking": "Ověřit a potvrdit rezervaci",
        "confirmEmailText": "Poslali jsme ověřovací kód na vaši e-mailovou adresu",
        "enterCodeText": "Zadejte prosím ověřovací kód, který vám byl zaslán",
        "didNotRecieveEmail": "Neobdrželi jste e-mail?",
        "changeEmailText": "Klikněte sem pro změnu e-mailové adresy",
        "verifyAndConfirm": "Ověřit a potvrdit",
        "verified": "OVĚŘENO",
        "bookingExpired": "Rezervace vypršela",
        "bookingExpiredText": "Je nám líto, ID rezervace, které používáte, vypršelo",
        "backToFindingBooking": "Zpět na hledání rezervace",
        "findMyBooking": "Najít moje rezervace",
        "bookingEmail": "E-mail rezervace",
        "reservationId": "ID rezervace",
        "findBooking": "NAJÍT REZERVACI",
        "abandonmentCartDoneText1": "Děkujeme!",
        "abandonmentCartDoneText2": "Podrobnosti košíku byly odeslány na e-mail. Pokračujte v rezervaci kdykoli.",
        "Recommended Currencies": "Doporučené měny",
        "All currencies": "Všechny měny",
        "thisIsRequiredField": "Toto je povinné pole"
    },
    "widget": {
        "destination": "Destinace",
        "enterDestination": "Zadejte destinaci",
        "guests": "Hosté",
        "guest": "Host",
        "nationality": "Národnost",
        "selectNationality": "Vyberte národnost",
        "nationalityIsRequired": "Národnost je povinná",
        "selectedRate": "Speciální sazba",
        "search": "Hledat",
        "ages": "Věk",
        "orAbove": "Nebo více",
        "child": "Dítě",
        "children": "Děti",
        "addAnotherRoom": "Přidat další pokoj",
        "removeRoom": "Odebrat pokoj",
        "property": "Nemovitost",
        "city": "Město",
        "country": "Země",
        "bookNow": "Rezervovat nyní",
        "overnightStay": "Přenocování",
        "dayUse": "Denní použití",
        "destinationIsRequired": "Destinace je povinná",
        "checkInIsRequired": "Datum příjezdu je povinné",
        "checkOutIsRequired": "Datum odjezdu je povinné",
        "noLocationFound": "Nebyla nalezena žádná lokalita",
        "soldOut": "Vyprodáno",
        "highDemand": "Vysoká poptávka",
        "dates": "Data",
        "allRates": "Všechny sazby jsou v",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Odjezd tentýž den"
    },
    "promotion": {
        "headingText": "Důležité informace pro",
        "regularRate": "Žádné",
        "seniorCitizen": "Sazba pro seniory",
        "agencyRate": "Agenturní sazba",
        "caaRate": "Sazba CAA/AAA",
        "corporateRate": "Firemní sazba",
        "governmentRate": "Vládní/vojenská sazba",
        "promotionalSpecialRate": "Propagační/speciální sazba",
        "regularRateDescription": "Nebyla použita žádná propagace.",
        "seniorCitizenRateDescription": "Toto je snížená hotelová sazba široce dostupná pro starší dospělé, typicky ve věku 60 let nebo starší.",
        "agencyRateDescription": "Toto je snížená hotelová sazba nabízená, ke které lze získat přístup pouze prostřednictvím konkrétních cestovních agentur podporujících partnerství a spolupráci.",
        "caaRateDescription": "Toto je speciální hotelová sazba nabízená členům AAA nebo CAA pro exkluzivní úspory.",
        "corporateRateDescription": "Toto je snížená hotelová sazba rozšířená na obchodní cestovatele, typicky vyjednávaná mezi hotelem a firemním subjektem.",
        "governmentRateDescription": "Tento cenový plán nabízí specifické slevy pro vládní/vojenský personál pro rezervaci hotelového pokoje.",
        "contentSeniorCitizen": "Doklad o datu narození je povinný při příjezdu. Nepředložení příslušného průkazu povede k účtování převládajících sazeb.",
        "contentAgencyRate": "Ujistěte se, že máte potvrzení rezervace a doklad totožnosti při příjezdu. Nepředložení těchto dokumentů povede k použití standardních sazeb.",
        "contentPromotionalSpecialRate": "Toto je snížená hotelová sazba nabízená po omezenou dobu, často vázaná na konkrétní události, sezóny nebo marketingové kampaně.",
        "contentCaaRate": "Ujistěte se prosím, že máte členskou kartu CAA nebo příslušnou identifikaci při příjezdu. Nepředložení příslušného průkazu povede k účtování převládajících sazeb.",
        "contentCorporateRate": "Doklad firemního průkazu nebo jiné oficiální dokumentace je vyžadován při příjezdu. Nepředložení příslušného dokladu povede k účtování převládajících sazeb.",
        "contentGovernmentRate": "Platný vládní nebo vojenský průkaz musí být předložen při příjezdu. Nepředložení požadované identifikace povede k účtování standardní sazby.",
        "CORP": "FIRMA",
        "AGEN": "AGENT",
        "PROM": "PROMO",
        "apply": "POUŽÍT",
        "Offer Code": "Kód nabídky",
        "Agency Code": "Kód agentury",
        "Corporate Code": "Firemní kód",
        "All-Access Rate": "Sazba s plným přístupem",
        "errorCode": "Tento kód není platný"
    }
}